import React from "react";

export default function Bucketsfast(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {
        return (<tr key={index}>
          <td scope="row ">{x.key.vehicleid}</td>
          <td >{(x.FC10_80TimeInMin.values["50.0"])} </td>
        </tr>)
      })}
    </>
  );
}